import React, { memo, useRef } from 'react'
import { faMagnifyingGlass } from '@fortawesome/pro-duotone-svg-icons'
import { InputAdornment, TextField } from '@mui/material'

import FaIcon from '../faIcon/FaIcon'

const SearchBar = ({ value, onChange, t, ...restProps }) => {
  const inputRef = useRef(null)

  return (
    <TextField
      inputRef={inputRef}
      placeholder={`${t('common.search')}...`}
      value={value}
      autoComplete='off'
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position='start'>
              <FaIcon icon={faMagnifyingGlass} />
            </InputAdornment>
          )
        }
      }}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={(e) => {
        const input = inputRef.current
        if (!input) return

        if ((e.ctrlKey || e.metaKey) && e.key === 'a') {
          input.select()
          e.preventDefault()
        }
        if (e.key === 'Backspace' || e.key === 'Delete') {
          onChange('')
          e.preventDefault()
        }
      }}
      {...restProps}
    />
  )
}

export default memo(SearchBar)
